import type { RedcatAnalyticsStore } from '../types/store';
import { OAuthTrackEventName } from '../types/oauth';
import type { OAuthProvider, OAuthSourceScreen } from '../types/oauth';
import type { OAuthTrackEvent } from '../types/events/track';

export const trackOAuthFlowStarted = (
  track: RedcatAnalyticsStore['track'],
  { provider, sourceScreen }: { provider: OAuthProvider; sourceScreen: OAuthSourceScreen },
) => {
  const event: OAuthTrackEvent = {
    name: OAuthTrackEventName.FlowStarted,
    properties: {
      provider,
      source_screen: sourceScreen,
    },
  };

  track(event);
};
